export const ChevronUp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="currentColor"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6"
      {...props}>
      <path d="M11.2801 8.22C11.4206 8.07931 11.6113 8.00018 11.8101 8H12.1901C12.3885 8.0023 12.5784 8.08112 12.7201 8.22L17.8501 13.36C17.9448 13.4539 17.998 13.5817 17.998 13.715C17.998 13.8483 17.9448 13.9761 17.8501 14.07L17.1401 14.78C17.0479 14.8741 16.9218 14.9271 16.7901 14.9271C16.6584 14.9271 16.5323 14.8741 16.4401 14.78L12.0001 10.33L7.5601 14.78C7.46621 14.8747 7.33842 14.9279 7.2051 14.9279C7.07178 14.9279 6.94398 14.8747 6.8501 14.78L6.1501 14.07C6.05544 13.9761 6.0022 13.8483 6.0022 13.715C6.0022 13.5817 6.05544 13.4539 6.1501 13.36L11.2801 8.22Z" />
    </svg>
  );
};
